// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Rgrr","colBig":"styles_colBig__3SIYG","colSmall":"styles_colSmall__3jwWQ"};